module.exports = __webpack_public_path__ + "static/img/member-area1.5a7365bb.png";